
export type MouseState = number;
export let MouseState: any = {};
MouseState.Moving = 0;
MouseState.Still = 1;
MouseState.Down = 2;
MouseState.Up = 3;
MouseState[MouseState.Moving] = "Moving";
MouseState[MouseState.Still] = "Still";
MouseState[MouseState.Down] = "Down";
MouseState[MouseState.Up] = "Up";
